import React from "react";
import "./Blog_outer_card.css";
import { Link } from "react-router-dom";

function Blog_outer_card({ post,imgSrc, innerText, date, description }) {
  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  
  
  return (
    <>
      <section className="Blog_outer_card">
        <div className="Blog_img_holder_main">
          <div className="Blog_img_holder">
            <img
              src={process.env.PUBLIC_URL + imgSrc}
              className="Blog_img"
              alt="Blog_img"
            />
          </div>

          <div className="card_inner_text_holder">
            <div className="card_inner_text">
              <Link to={`/blog-inner/${post}`}>
                <p>{innerText}</p>
              </Link>
            </div>
            <div className="date_holder">
              <p>- {formatDate(date)}</p>
            </div>
          </div>

          <div className="overlay_holder"></div>
        </div>

        <div className="card_outer_text_holder">
          <p>{description}</p>
        </div>
      </section>
    </>
  );
}

export default Blog_outer_card;
